// export type SectionType = 'featured' | 'new-arrivals' | 'best-sellers' | 'category-spotlight' | 'banner';
export var SectionType;
(function (SectionType) {
    SectionType["FEATURED"] = "featured";
    SectionType["NEW_ARRIVALS"] = "new-arrivals";
    SectionType["BEST_SELLERS"] = "best-sellers";
    SectionType["CATEGORY_SPOTLIGHT"] = "category-spotlight";
    SectionType["BANNER"] = "banner";
})(SectionType || (SectionType = {}));
